let moment = require('moment');
require('moment-timezone');
const DEFAULT_TIMEZONE_KEY = 'EST';
const TIMEZONES = {
  EST: 'America/New_York'
};

let FILTERS = {
  uppercase: function(row) {
    return row.charAt(0).toUpperCase() + row.slice(1);
  },
  uppercaseAllWords: function(row) {
    return row.replace(/(^|\s)([a-z])/g, (m, p1, p2) => {
      return p1 + p2.toUpperCase();
    });
  },
  maxPrettifyDate: function(row) {
    let moments = row.map(d => moment.utc(d));
    return `${moment.max(moments).format('MM/DD/YYYY')}`;
  },

  prettifyDateTime: function(row) {
    return `${moment(row).tz(TIMEZONES[DEFAULT_TIMEZONE_KEY]).format('MM/DD/YYYY HH:mm:ss')} ${DEFAULT_TIMEZONE_KEY}`;
  },
  fullEdition: function(row) {
    return (row ? (row === 'T' ? 'Teacher' : 'Student') : '');
  },
  spacify: function(row) {
    return row.split(/(?=[A-Z])/).join(' ');
  },
  prettifyDate: function(row) {
    return `${moment.utc(row).format('MM/DD/YYYY')}`;
  }
};

export
default FILTERS;


// WEBPACK FOOTER //
// ./app/models/filters.js